<template>
  <div>
    <RenderMoneyColumnValue :value="invoiceValue" /> |
    <RenderPanoramaInvoiceStatus
      :panorama-invoice-status="panoramaInvoiceStatus"
    />
  </div>
</template>

<script>
import { RenderMoneyColumnValue } from '../../../ui/render';
import RenderPanoramaInvoiceStatus from './render-panorama-invoice-status-value.vue';

export default {
  components: { RenderMoneyColumnValue, RenderPanoramaInvoiceStatus },
  props: {
    invoiceValue: {
      type: Number,
      default: 0,
    },
    panoramaInvoiceStatus: {
      type: String,
      default: '',
    },
  },
};
</script>
